import { render, staticRenderFns } from "./PersonalSiblingInformationTable.vue?vue&type=template&id=1eba4062"
import script from "./PersonalSiblingInformationTable.vue?vue&type=script&lang=js"
export * from "./PersonalSiblingInformationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports